import styled from 'styled-components'

export const MainWrapper = styled.div`
  padding: 24px;
  height: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: flex-start;
`

export const ModalHead = styled.div`
  padding: 0px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-content: center;
`

export const ModalContent = styled.div`
  margin-top: 25px;
`

export const ModalFooter = styled.div`
  margin-top: auto;
  padding: 0px 24px 24px 20px;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: center;
  align-items: end;
`

export const ContainerButtonModal = styled.div`
  margin-top: 10px
`

export const ContainerHeader = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`